export default __webpack_public_path__ + "static/tree-planting-hero-a917d630e5e886920575146875391d13.jpeg";